import { Big, BN } from '@switchboard-xyz/common';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const baseJsonReplacers = (key: any, value: any): any => {
  if (
    !value ||
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  ) {
    return value;
  }

  if (value instanceof Big) {
    return value.toString();
  }

  if (BN.isBN(value)) {
    return value.toString(10);
  }

  return value;
};
